import 'consumerweb-shim';
import 'adsinterceptor';
import { Header, Footer } from 'marketing-components';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import {
  Link,
  ArrowLeftIcon,
  BodyText,
  CaptionText,
  PAYPAL_THEME,
} from '@paypalcorp/pp-react';

import { ThemeProvider } from '@emotion/react';

import SearchBoxWithSheet from '../redesignComponents/searchBoxWithSheet/searchBoxWithSheet';
import CharityList from '../components/charityList';
import FundraiserList from '../components/fundraiserList';
import SearchSuggestion from '../components/searchSuggestion';
import { NoSearchResults } from '../redesignComponents/noSearchResult/noSearchResults';
import styles from './searchPage.less';

import {
  HUB_PAGE_GROUP,
  HUB_PAGE_SEARCH_PAGE,
} from '../lib/fptiTrackingVariables';

import * as analytics from '../lib/analytics';

const containerStyle = {
  maxWidth: '1024px',
  margin: 'auto',
};

import content from '../lib/i18n';
import { DataContext } from '../lib/context';
import { getHeaderClassName, getHeaderProps } from '../lib/header';
const i18n = content('hubSearchPage');

if (window.PAYPAL && window.PAYPAL.analytics) {
  window.PAYPAL.analytics.startClientErrorTracking();
}

class Page extends React.Component {
  static propTypes = {
    csrf: PropTypes.string,
  };

  static childContextTypes = {
    csrf: PropTypes.string,
  };

  constructor(props, context) {
    super(props, context);

    var initialState = {
      isMobile: false,
      fptiInfo: {
        pgrp: HUB_PAGE_GROUP,
        page: HUB_PAGE_SEARCH_PAGE,
      },
    };
    this.state = initialState;
  }

  parseFPTIInfo = (fptiData) => {
    var nameValues = [];
    var pairs = decodeURIComponent(fptiData).split('&');
    var i;
    for (i = 0; i < pairs.length; i++) {
      var parts = pairs[i].split('=');
      nameValues[parts[0]] = parts[1];
    }
    return nameValues;
  };

  getChildContext() {
    return {
      csrf: this.props.csrf,
    };
  }

  recordScreenShownEvent = () => {
    let searchResults = 'both';
    if (
      Array.isArray(this.props.charities) &&
      this.props.charities.length > 0 &&
      (!this.props.campaigns || this.props.campaigns.length < 1)
    ) {
      searchResults = 'charities_only';
    }

    if (
      Array.isArray(this.props.campaigns) &&
      this.props.campaigns.length > 0 &&
      (!this.props.charities || this.props.charities.length < 1)
    ) {
      searchResults = 'fundraisers_only';
    }

    if (
      Array.isArray(this.props.charities) &&
      this.props.charities.length < 1 &&
      Array.isArray(this.props.campaigns) &&
      this.props.campaigns.length < 1
    ) {
      searchResults = 'no_results';
    }

    analytics.instance.recordEvent(
      analytics.events.DW_GIVING_BROWSE_FUNDRAISER_CHARITY_SCREEN_SHOWN,
      {
        e: 'im',
        product: 'dw_giving',
        tile_id: 'search_results',
        event_source: analytics.getEventSource(this.state.isMobile),
        account_type: analytics.getAccountType(this.props.authState),
        acct_cntry: this.props.contentCountry,
        filter_type: this.props.searchType ? this.props.searchType : '',
        state: this.props.query.state ? this.props.query.state : '',
        category_code: this.props.query.category
          ? this.props.query.category
          : '',
        search_results: searchResults,
      }
    );
  };

  componentDidMount() {
    let isMobile = false;
    if (/Android|webOS|iPhone|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      isMobile = true;
      this.setState({
        isMobile,
      });
    }

    // to replace the default /signin href from marketing header
    // we need it to go back to npo page
    const marketingULButton = document.getElementById('ul-btn') || {};
    marketingULButton.href = this.props.unifiedLoginURL;
    this.recordScreenShownEvent();
  }

  handleAnalyticsInviteLink = () => {
    analytics.trackLink(
      'PPGFInviteLink',
      this.state.fptiInfo.pgrp,
      this.state.fptiInfo.page,
      'link'
    );

    analytics.instance.recordEvent(
      analytics.events
        .DW_GIVING_BROWSE_FUNDRAISER_CHARITY_PPGF_SUBSCRIPTION_PRESSED,
      {
        e: 'cl',
        product: 'dw_giving',
        tile_id: 'search_results',
        event_source: analytics.getEventSource(this.state.isMobile),
        account_type: analytics.getAccountType(this.props.authState),
        acct_cntry: this.props.contentCountry,
        filter_type: this.props.searchType ? this.props.searchType : '',
        state: this.props.query.state ? this.props.query.state : '',
        category_code: this.props.query.category
          ? this.props.query.category
          : '',
      }
    );
  };

  renderFooter = () => {
    const {
      content: { content: footerContent, config = {} },
    } = JSON.parse(document.getElementById('data-footer').innerHTML);
    const { localeCountry } = footerContent;

    return (
      <Footer
        config={config}
        content={footerContent}
        localeCountry={localeCountry}
      />
    );
  };

  renderHeader = () => {
    const dataHeader = JSON.parse(
      document.getElementById('data-header').innerHTML
    );

    const props = getHeaderProps(this.props.authState, dataHeader.content);

    return (
      <div className={getHeaderClassName('v3')}>
        <Header {...props} />
      </div>
    );
  };

  render() {
    let hasCharitiesSearchResult = false;
    let hasCampaignSearchResult = false;

    if (
      Array.isArray(this.props.charities) &&
      this.props.charities.length > 0
    ) {
      hasCharitiesSearchResult = true;
    }

    if (
      Array.isArray(this.props.campaigns) &&
      this.props.campaigns.length > 0
    ) {
      hasCampaignSearchResult = true;
    }

    const totalSearchResultsCharities = Array.isArray(this.props.charities)
      ? this.props.charities.length
      : 0;

    const totalSearchResultsFundraisers = Array.isArray(this.props.campaigns)
      ? this.props.campaigns.length
      : 0;

    const totalSearchResults =
      totalSearchResultsCharities + totalSearchResultsFundraisers;

    const ppgfLink = (
      <CaptionText style={{ margin: '0 15px 0 15px' }}>
        {`${i18n('label.dont-see-fav-charity')}`}
        &nbsp;
        <Link
          theme='v2'
          onClick={this.handleAnalyticsInviteLink}
          target={'_blank'}
          href={`${i18n('label.ppgf-link')}`}
        >
          <CaptionText
            strong
            style={{
              display: 'inline',
              color: PAYPAL_THEME.sysColorSecondaryMain,
            }}
          >
            {`${i18n('label.ppgf-text')}`}
          </CaptionText>
        </Link>
      </CaptionText>
    );

    const searchSuggestionComponent = (flag) =>
      totalSearchResults <= 5 &&
      showCategory && (
        <SearchSuggestion
          {...this.props}
          i18n={i18n}
          fptiInfo={this.state.fptiInfo}
          noSearchResult={flag}
          showCategory={showCategory}
          coBrand={`${coBrand}hub`}
        />
      );

    let result;
    let showCategory = !this.props.charityListUnderThreshold;
    const noSearchResult = (
      <>
        <NoSearchResults
          header={i18n('label.no-results-found')}
          subHeader={
            (this.props.query.type && this.props.query.type !== 'all') ||
            (this.props.query.category && this.props.query.category !== '') ||
            (this.props.query.state && this.props.query.state !== '')
              ? i18n('label.try-removing-filters')
              : i18n('label.try-again-or-browse')
          }
        />
        {searchSuggestionComponent(true)}
      </>
    );

    if (this.props.searchType === 'charities') {
      // Searching only by charities
      if (!hasCharitiesSearchResult) {
        // There are no results of charities
        result = noSearchResult;
      } else {
        result = (
          <>
            <CharityList
              {...this.props}
              fptiInfo={this.state.fptiInfo}
              i18n={i18n}
            />
            {searchSuggestionComponent(false)}
          </>
        );
      }
    } else if (this.props.searchType === 'fundraisers') {
      // Searching only by fundraisers
      if (!hasCampaignSearchResult) {
        // There are no results of fundraisers
        result = noSearchResult;
      } else {
        result = (
          <>
            <FundraiserList
              {...this.props}
              fptiInfo={this.state.fptiInfo}
              i18n={i18n}
            />
            {searchSuggestionComponent(false)}
          </>
        );
      }
    } else {
      // Unified experience
      if (!hasCharitiesSearchResult && !hasCampaignSearchResult) {
        // There are no results of charities and fundraisers
        result = noSearchResult;
      } else {
        result = (
          <>
            {hasCharitiesSearchResult && (
              <CharityList
                {...this.props}
                fptiInfo={this.state.fptiInfo}
                i18n={i18n}
              />
            )}
            <br />
            <br />
            {hasCampaignSearchResult && (
              <FundraiserList
                {...this.props}
                fptiInfo={this.state.fptiInfo}
                i18n={i18n}
              />
            )}
            <br />
            <br />
            {searchSuggestionComponent(false)}
          </>
        );
      }
    }

    return (
      <div>
        {this.props.mppHeader && this.renderHeader()}
        <div style={containerStyle}>
          <div className={styles.searchBox}>
            <SearchBoxWithSheet
              {...this.props}
              i18n={i18n}
              isMobile={this.state.isMobile}
              fptiInfo={this.state.fptiInfo}
            />
          </div>
          {result}
          {this.props.searchType === 'charities' &&
            (this.props.allowedCharityType === 'DIRECT_MODEL_ENROLLED'
              ? undefined
              : ppgfLink)}
        </div>
        {this.props.mppFooter && this.renderFooter()}
      </div>
    );
  }
}

const data = JSON.parse(document.getElementById('data-props').innerHTML);
const campaign = JSON.parse(
  document.getElementById('data-campaign').innerHTML || '{}'
);
const resources = JSON.parse(
  document.getElementById('data-resources').innerHTML
);
const locale = JSON.parse(document.getElementById('data-locale').innerHTML);
const contentCountry = locale.country;
const supportedProduct = data.supportedProduct;
const charities = data.charities;
const maxCharityResults = data.maxCharityResults;
const campaigns = data.campaigns;
const totalItems = data.totalItems;
const totalPages = data.totalPages;
const totalCampaignsItems = data.totalCampaignsItems;
const totalCampaignsPages = data.totalCampaignsPages;
const suggestedCharties = data.suggestedCharties;
const allowedCharityType = data.allowedCharityType;
const states = data.states;
const categories = data.categories;
const fundraiserCategories = data.fundraiserCategories;
const query = data.query;
const searchType = data.searchType;
const labels = data.labels;
const csrf = document.getElementById('data-csrf').innerHTML;
const coBrand = document.getElementById('data-co-brand').innerHTML;
const fptiInfo = JSON.parse(
  document.getElementById('data-fpti-info').innerHTML
);
const charityUrl = `${coBrand}charity`;
const hubUrl = `${coBrand}hub`;
const searchUrl = document.getElementById('data-search-url').innerHTML;
const mppFooter = data.mppFooter;
const mppHeader = data.mppHeader;
const unifiedLoginURL = data.unifiedLoginURL;
const charityListUnderThreshold = data.charityListUnderThreshold;
const cdnHost = data.cdnHost;
const domain = data.domain;
const authState = data.authState;

ReactDOM.render(
  <DataContext.Provider value={data}>
    <ThemeProvider theme={PAYPAL_THEME}>
      <Page
        supportedProduct={supportedProduct}
        query={query}
        charities={charities}
        maxCharityResults={maxCharityResults}
        campaigns={campaigns}
        totalCampaignsItems={totalCampaignsItems}
        totalCampaignsPages={totalCampaignsPages}
        totalItems={totalItems}
        totalPages={totalPages}
        searchType={searchType}
        suggestedCharties={suggestedCharties}
        allowedCharityType={allowedCharityType}
        categories={categories}
        fundraiserCategories={fundraiserCategories}
        fptiInfo={fptiInfo}
        states={states}
        labels={labels}
        coBrand={coBrand}
        csrf={csrf}
        searchUrl={searchUrl}
        charityUrl={charityUrl}
        resources={resources}
        hubUrl={hubUrl}
        campaign={campaign}
        mppFooter={mppFooter}
        mppHeader={mppHeader}
        charityListUnderThreshold={charityListUnderThreshold}
        unifiedLoginURL={unifiedLoginURL}
        cdnHost={cdnHost}
        domain={domain}
        authState={authState}
        contentCountry={contentCountry}
      />
    </ThemeProvider>
  </DataContext.Provider>,
  document.getElementById('page')
);
